import { precogAccountedEntriesConstants } from "../../../actions/precog/accountedEntries";

const defaultState = {
  status: {
    started: false,
    ended: false,
    error: false
  },
  data: []
};

export function accountedEntries(state = defaultState, { type, payload }) {
  switch (type) {
  case precogAccountedEntriesConstants.GET_ACCOUNTEDENTRIES_DATA_START:
    return {
      ...state, 
      status: {
        started: true,
        ended: false,
        error: false
      }
    };
  case precogAccountedEntriesConstants.GET_ACCOUNTEDENTRIES_DATA_SUCCESS:
    return {
      ...state,
      status: {
        started: false,
        ended: true,
        error: false
      },
      data: payload?.data
    };
  case precogAccountedEntriesConstants.GET_ACCOUNTEDENTRIES_DATA_ERROR:
    return {
      ...state,
      status: {
        started: false,
        ended: true,
        error: true
      }
    };
  default:
    return state;
  }
}